export default __webpack_public_path__ + "static/media/Signature.b9141332.png";